var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.translate.result.direct.received)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.translate.result.direct.instruction)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.translate.result.direct.whatsapp)+" "),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.translate.result.direct.thanks)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }